import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Nav, NavItem, NavLink, Table, TabPane, TabContent, Col, Form, FormGroup, Label, Input, Button, Alert, CustomInput } from "reactstrap";
import classnames from 'classnames';
import S3 from 'react-aws-s3';
import Moment from 'moment';

import { testimonyFormOptionsUrl, internmentUrl, internmentMetaDataFilesUrl, internmentMetaDataUrl } from "../../helpers/url";
//select
import Select from 'react-select';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

class AddFacility extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "UTJD", link : "/dashboard" },
                { title : "Add Facility", link : "#" },
            ],
            activeTab: 1,
            selectedFiles: [],
            name: '',
            internalId: '',
            geolocation: '',
            degree: '',
            type: 0,
            remarks: '',
            landCode: '',
            established: '',
            reference: '',
            landCode: 0,
            mainImage: '',
            category: '',
            subfolder: '',
            facilityId: 0,
            tags: '',
            
            fileName: "",
            fileLocation: "",

            metaId: 0,
            metavalue: "",
            metadate: "",
            metatitle: "",
            metadescription: "",
            metaremarks: "",
            metakeywords: "",
            metacategory: 0,
            metareference: "",
            metacaption: "",

            fileUploading: false,
            fileSuccess: false,

            landCodes: [], 
            metadataTypes: [], 
            facilityTypes: [], 
            facilityTags: [], 
            formFieldData: [], 

            metainfo: [
                
             ]
        }
        this.toggleTab = this.toggleTab.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.metaDataAdd = this.metaDataAdd.bind(this);
        this.renderTableData = this.renderTableData.bind(this);
        this.addImage = this.addImage.bind(this);
        this.storeMetaDataUrl = this.storeMetaDataUrl.bind(this);
        this.handleChangeMulti = this.handleChangeMulti.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        
		let formFieldData = fetch(testimonyFormOptionsUrl, {
			method: 'GET',
            headers: { "Content-Type": "application/json" , "Authorization": accessToken }
		}).then(res => res.json());

		Promise.all([formFieldData])
			.then(([formFieldDataOutput]) => {
                this.setState({
                    landCodes: formFieldDataOutput.landCodes,
                    metadataTypes: formFieldDataOutput.metadataTypes,
                    facilityTypes: formFieldDataOutput.internmentTypes
                });

                const listItems = formFieldDataOutput.internmentTags.map(item => ({
                    value: item.abbr,
                    label: item.tagName,
                  }));

                 this.setState({
                    facilityTags: listItems 
                 });

			})
			.catch(err => {
				this.setState({
					loading: false,
					error: true,
					errorMsg: err,
				});
			});
        
	}

    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
    }

    handleChangeMulti = (e) => {
        let values = e.map(({value}) => `${value}`).join(',');
        this.setState({tags: values});
      }
    
    handleSubmit(event) {
        const session = JSON.parse(sessionStorage.getItem('authUser'));
		const userId = session.payload.sub;
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        var unixTimestamp = new Date(this.state.established).getTime() / 1000;
        
        fetch(internmentUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" , "Authorization": accessToken },
            body: JSON.stringify({
                facilityId: 0,
                facilityName: this.state.name, 
                facilityInternalId: this.state.internalId,
                remarks: this.state.remarks,
                landCode: this.state.landCode,
                established: unixTimestamp,
                geolocation: this.state.geolocation,
                degree: this.state.degree,
                facilityType : this.state.type,
                mainImage: this.state.mainImage,
                reference: this.state.reference,
                tags: this.state.tags,
                userId: userId
            })
        }).then(res => res.json())
        .then(data => {
            this.setState({
                activeTab: 2,
                facilityId: data
            });
        })
        event.preventDefault();
    }

    addImage = async (event) => {
        let mid = event.currentTarget.getAttribute('data-mid');

        this.setState({
            fileUploading: true
        })
        Moment.locale('en');
        let dt = new Date
        let date = Moment(dt).format('YYYY-MM-DD')
        let file = event.target.files[0]
        let fileName = "facility/" + this.state.facilityId + "/metadata/" + this.state.metacategory + "/" + date + "/" + event.target.files[0].name;

        this.setState({
            fileName: event.target.files[0].name
        })

        const config = {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID
        };
        const ReactS3Client = new S3(config);

        await ReactS3Client.uploadFile(file, fileName)
        .then((data) => {
            this.storeMetaDataUrl(mid, data)
            this.setState({
                fileLocation: data.location,
                fileSuccess: true,
                fileUploading: false
            })}
        )
        .catch((err) => {
            this.setState({
                error: true,
                errorMsg: "Failed: " + err
            })}
        )
        event.preventDefault();
    }

    storeMetaDataUrl(mid, data) {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = authUser.jwtToken
		const userId = authUser.payload.sub;

        fetch(internmentMetaDataFilesUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                metadataFileId: 0,
                metadataId: mid, 
                metadataFileKey: data.key,
                metadataLocation: data.location,
                userId: userId
            })
        }).then(res => res.json())
        .then(data => {
            console.log(data);
        })
    }

    fileAutoSubmitToS3 = async (event) => {
        this.setState({
            fileUploading: true
        })
        Moment.locale('en');
        let dt = new Date()
        let date = Moment(dt).format('YYYY-MM-DD')
        let file = event.target.files[0]
        let fileName = "facility/" + this.state.facilityId + "/" + this.state.category  + this.state.subfolder + "/" + date + "/" + event.target.files[0].name;

        this.setState({
            fileName: event.target.files[0].name
        })

        const config = {
            bucketName: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION,
            accessKeyId: process.env.REACT_APP_ACCESS_KEY_ID,
            secretAccessKey: process.env.REACT_APP_SECRET_KEY_ID
        };
        const ReactS3Client = new S3(config);

        await ReactS3Client.uploadFile(file, fileName)
        .then((data) => {
             this.setState({
                 fileLocation: data.location,
                 fileSuccess: true,
                 fileUploading: false
             })}
        )
        .catch((err) => {
            this.setState({
                error: true,
                errorMsg: "Failed: " + err
            })}
        )
    }

    detailState = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    toggleTab(event) {
        let tab = parseInt(event.currentTarget.getAttribute('data-tab'), 10);
        if (this.state.activeTab !== tab) {
            if(tab >= 1 && tab <=3 ){
                this.setState({
                    activeTab: tab
                });
            }
        }
        event.preventDefault();
    }

    renderTableData() {
        return this.state.metainfo.map((mdata, index) => {
           const { id, mtitle, desc, mdate } = mdata //destructuring
           return (
              <tr key={id}>
                <td>{id}</td>
                <td>{mtitle}</td>
                <td>{desc}</td>
                <td>{mdate}</td>
                <td>
                    <CustomInput type="file" className="custom-file-input" data-mid={id} id="customFile" onChange={this.addImage}/>
                    <i className="mdi mdi-book-plus-multiple-outline"></i>Upload Image
                </td>
              </tr>
           )
        })
     }

    metaDataAdd(event) {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = authUser.jwtToken
		const userId = authUser.payload.sub;
        var unixTimestamp = new Date(this.state.metadate).getTime() / 1000;

        fetch(internmentMetaDataUrl, {
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify({
                metaId: 0,
                facilityId: this.state.facilityId,
                metaValue: this.state.metavalue,
                metaDate: unixTimestamp,
                metaTitle: this.state.metatitle,
                metaDescription: this.state.metadescription,
                metaRemarks: this.state.metaremarks,
                metaCaption: this.state.metacaption,
                metaKeywords: this.state.metakeywords,
                metaCategory: this.state.metacategory,
                metaReference: this.state.metareference,
                userId: userId
            })
        }).then(res => res.json())
        .then(data => {
            if(data == 0){
                console.log("Error occured while storing metadata");
                return;
            }
            this.state.metainfo.push({id: data,
                mtitle: this.state.metatitle,
                desc: this.state.metadescription,
                mdate: this.state.metadate
                })
            this.setState({
                metaId: data
            });
            document.getElementById("meta-data-form").reset();
        })
        event.preventDefault();
    }

    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Add Facility" breadcrumbItems={this.state.breadcrumbItems} />

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        
                                        <div id="addproduct-nav-pills-wizard" className="twitter-bs-wizard">
                                            <Nav pills justified className="twitter-bs-wizard-nav">
                                                <NavItem>
                                                    <NavLink className={classnames({ active: this.state.activeTab === 1 })}>
                                                        <span className="step-number">01</span>
                                                        <span className="step-title">Basic Info</span>
                                                    </NavLink>
                                                </NavItem>
                                                <NavItem>
                                                    <NavLink className={classnames({ active: this.state.activeTab === 2 })}>
                                                        <span className="step-number">02</span>
                                                        <span className="step-title">Facility Img</span>
                                                    </NavLink>
                                                </NavItem>
                                                
                                                <NavItem>
                                                    <NavLink className={classnames({ active: this.state.activeTab === 3 })}>
                                                        <span className="step-number">03</span>
                                                        <span className="step-title">Meta Data</span>
                                                    </NavLink>
                                                </NavItem>
                                            </Nav>
                                            <TabContent activeTab={this.state.activeTab} className="twitter-bs-wizard-tab-content">
                                                <TabPane tabId={1}>
                                                    <h4 className="card-title">Basic Information</h4>
                                                    <p className="card-title-desc">Fill all information below</p>

                                                    <Form onSubmit={this.handleSubmit}>
                                                        <FormGroup>
                                                            <Label htmlFor="name">Facility Name</Label>
                                                            <Input id="name" name="name" type="text" 
                                                             value={this.state.value} 
                                                             onChange={this.handleChange} 
                                                            className="form-control"/>
                                                        </FormGroup>
                                                        <Row>
                                                            <Col lg={4}>
                                                                <FormGroup>
                                                                    <Label htmlFor="internalId">Internal ID</Label>
                                                                    <Input id="internalId" name="internalId" type="text" 
                                                                    value={this.state.value} 
                                                                    onChange={this.handleChange}
                                                                    className="form-control"/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg={4}>
                                                                
                                                                <FormGroup>
                                                                    <Label htmlFor="geolocation">Geolocation</Label>
                                                                    <Input id="geolocation" name="geolocation" type="text" 
                                                                     value={this.state.value} 
                                                                     onChange={this.handleChange}
                                                                    className="form-control"/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col lg={4}>
                                                                <FormGroup>
                                                                    <Label htmlFor="degree">Degrees</Label>
                                                                    <Input id="degree" name="degree" type="text" 
                                                                     value={this.state.value} 
                                                                     onChange={this.handleChange} 
                                                                    className="form-control"/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label className="control-label">Facility Type</Label>
                                                                    <select className="form-control select2" 
                                                                    name = "type" 
                                                                    value={this.state.value} 
                                                                    onChange={this.handleChange}>
                                                                        {this.state.facilityTypes.map((data, id) => (
																			<option key={id} value={data.id}>
																				{data.typeEn}
																			</option>
																		))}
                                                                    </select>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={6}>
                                                                <FormGroup>
                                                                    <Label className="control-label">County/District/City</Label>
                                                                    <select className="form-control select2" 
                                                                    name = "landCode" 
                                                                    value={this.state.value} 
                                                                    defaultValue={0} 
                                                                    onChange={this.handleChange}>
                                                                        {this.state.landCodes.map((data, id) => (
																			<option key={id} value={data.codeId}>
																				{data.perfectureCityEN}, {data.cityCountyEN}
																			</option>
																		))}
                                                                    </select>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>
                                                        <Row>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label htmlFor="reference">Reference/Credit</Label>
                                                                    <Input id="reference" name="reference" type="text" 
                                                                    value={this.state.value} 
                                                                    onChange={this.handleChange}
                                                                    className="form-control"/>
                                                                </FormGroup>
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label htmlFor="reference">Established Date</Label>
                                                                    <Input
                                                                        type="date"
                                                                        name="established"
                                                                        id="established"
                                                                        placeholder="Date of the establishment YYYY-MM-DD"
                                                                        onChange={this.handleChange}
                                                                        value={this.state.value}
                                                                    />
                                                                </FormGroup>	
                                                            </Col>
                                                            <Col md={4}>
                                                                <FormGroup>
                                                                    <Label className="control-label">Tags</Label>
                                                                    <Select
                                                                        defaultValue={[]}
                                                                        isMulti
                                                                        name="tags"
                                                                        options={this.state.facilityTags} 
                                                                        onChange={this.handleChangeMulti} 
                                                                        className="select2 select2-multiple"
                                                                    />
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>

                                                        <FormGroup>
                                                            <Label htmlFor="remarks">Description/Remarks</Label>
                                                            <textarea className="form-control" id="remarks" name="remarks" rows="5" 
                                                             value={this.state.value} 
                                                             onChange={this.handleChange} 
                                                            ></textarea>
                                                        </FormGroup>
                                                        <Input type="submit" value="Submit" />
                                                    </Form>
                    
                                                </TabPane>
                                                <TabPane tabId={2}>
                                                    <h4 className="card-title">File Upload</h4>
                                                    <p className="card-title-desc">Upload relevant files</p>
                                                    <Form>
                                                    <Row>
                                <Col lg={12}>
                                <Card>
                                <CardBody>
                                
                                <FormGroup row className="mb-0" >
                                    <Label className="col-md-2 col-form-label">Category</Label>
                                    <Col md={10}>
                                    <select className="custom-select" id="category" placeholder="pick" onChange={this.detailState}>
                                        <option defaultValue value="notdefined">Select category</option>
                                        <option value="main-img">Display Image</option>
                                        <option value="video">Video</option>
                                        <option value="ground">Ground</option>
                                        <option value="documents">Documents</option>
                                        <option value="files">Files</option>
                                        <option value="maps">Maps</option>
                                        <option value="research">Research Paper</option>
                                        <option value="3d">Camp 3D Model</option>
                                        <option value="others">Others</option>
                                    </select>
                                    </Col>
                                </FormGroup>
                                <FormGroup row className="mb-0" >
                                    <Label className="col-md-2 col-form-label">Subfolder</Label>
                                    <Col md={10}>
                                        <Input className="form-control" type="text" placeholder="/subfolder" id="subfolder" onChange={this.detailState}/>
                                        <p className="card-title-desc"> Please provide subfolder if required. Has to follow strictly following rule  Ex:<em>/subfolder</em>. Each subfolder has to start / sign followed by name for subfolder </p>
                                    </Col>
                                </FormGroup>
                                </CardBody>
                                </Card>
                                </Col>
                                
                                <Col lg={12}>
                                <Card>
                                
                                <CardBody>
                                    
                                    <h4 className="card-title">File browser</h4>
                                    <p className="card-title-desc">Please  <em>Choose file…</em> to upload to server. Big size file require some time please await it completes uploading. The data submitted here is not meta data related files.</p>
                                    <div className="custom-file mb-4">
                                        <CustomInput type="file" className="custom-file-input" id="customFile" onChange={this.fileAutoSubmitToS3}/>
                                        <Label className="custom-file-label" htmlFor="customFile">Choose file</Label>
                                    {this.state.fileUploading ? <div role="status" class="me-2 spinner-border text-info"><span class="sr-only">Loading...</span></div> : ""}
                                    
                                        <Alert color="success" isOpen={this.state.fileSuccess} >
                                        {this.state.fileName} uploaded
                                        </Alert>
                                    </div>
                                </CardBody>
                               
                                
                                </Card>
                                <Label>Please move to next session if all necessary documents are submitted.</Label>
                                <Button block onClick={this.toggleTab} data-tab="3" >Add Meta Data</Button>
                                </Col>
                                
                                
                            </Row>
                                                    </Form>

                                                </TabPane>
                                                <TabPane tabId={3}>
                                                    <h4 className="card-title">Meta Data</h4>
                                                    <p className="card-title-desc">Fill all information below. You can add multiple meta data.</p>

                                                    <Form id="meta-data-form">
                                                        <Row>
                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metatitle">Meta title</Label>
                                                                    <Input id="metatitle" name="metatitle" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                                
                                                            </Col>
                    
                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metacaption">Meta Caption</Label>
                                                                    <Input id="metacaption" name="metacaption" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metacategory">Category</Label>
                                                                    <select className="custom-select" id="metacategory" placeholder="pick" onChange={this.detailState}>
                                                                        <option defaultValue value="0">Select category</option>
                                                                        {this.state.metadataTypes.map((data, id) => (
																			<option key={id} value={data.metadataId}>
																				{data.metadataType}  {data.metadataUnit !== null ? "("+data.metadataUnit+")" : "" }
																			</option>
																		))}
                                                                    </select>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metavalue">Value</Label>
                                                                    <Input id="metavalue" name="metavalue" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metadate">Date</Label>
                                                                    <Input
                                                                        type="date"
                                                                        name="metadate"
                                                                        id="metadate"
                                                                        placeholder="Date: YYYY-MM-DD"
                                                                        onChange={this.handleChange}
                                                                        value={this.state.value}
                                                                    />
                                                                </FormGroup>
                                                            </Col>

                                                            <Col sm={6}>
                                                                <FormGroup>
                                                                    <Label htmlFor="metareference">Reference</Label>
                                                                    <Input id="metareference" name="metareference" type="text" className="form-control" onChange={this.detailState}/>
                                                                </FormGroup>
                                                            </Col>
                                                        </Row>

                                                        <FormGroup>
                                                            <Label htmlFor="metadescription">Meta Clarification</Label>
                                                            <textarea className="form-control" id="metadescription" rows="5" onChange={this.detailState}></textarea>
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Label htmlFor="metaremarks">Meta Remarks</Label>
                                                            <textarea className="form-control" id="metaremarks" rows="5" onChange={this.detailState}></textarea>
                                                        </FormGroup>
                                                    </Form>

                                                    <div className="text-center mt-4">
                                                        <Button color="primary" type="button" className="mr-2 waves-effect waves-light" onClick={this.metaDataAdd}>Save Changes</Button>
                                                        <Button color="light" type="button" className="waves-effect ml-1">Cancel</Button>
                                                    </div>

                                                    <div>
                                                        <h4 className="card-title">Added Meta Information</h4>
                                                        <Table id="mdata" striped bordered responsive>
                                                        <tbody>
                                                            {this.renderTableData()}
                                                        </tbody>
                                                        </Table>
                                                    </div>
                                                </TabPane>
                                            </TabContent>
                                            <ul className="pager wizard twitter-bs-wizard-pager-link">     
                                            </ul>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>

                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default AddFacility;